import React from 'react';

const Virginia = () => {
  return (
    <div>
      <h2></h2>
      <ol>
        <li>
          Disclosure of known defects required; no specific form mandated.
        </li>
        <li>Residential Property Disclosure Statement: Required by law..</li>
        <li>
          Virginia sellers are not obligated to disclose material defects before
          selling. Unless otherwise agreed upon, it is the buyer’s
          responsibility to conduct a home inspection to examine the condition
          of the property. With that said, sellers must still give buyers the
          necessary disclosure statements, all of which can be accessed below.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Lead-Based Paint Disclosure{' '}
          </span>
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Virginia-Building-Code-or-Zoning-Ordinance-Violations-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Residential Property Disclosure Form{' '}
          </span>
          – Informs the buyer of any impending building code violations or local
          zoning ordinance issues.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Virginia-Flood-Risk-Information-Form.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Residential Property Disclosure Form{' '}
          </span>
          – Provides buyers with information regarding flood risk on the
          property.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Lead-Based Paint Disclosure{' '}
          </span>
          - Must be provided for homes built before 1978 to disclose lead paint
          history.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Virginia-Methamphetamine-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Methamphetamine Disclosure{' '}
          </span>
          – Discloses if the property was previously used for methamphetamine
          production and is yet to be cleaned according to state health
          procedures.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Virginia-Military-Air-Installation-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Military Air Zone Disclosure{' '}
          </span>
          – Informs buyers if the property is located in a military air zone
          with increased noise levels
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Virginia-Privately-Owned-Stormwater-Management-Facility-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Privately Owned Stormwater Management Facility Disclosure{' '}
          </span>
          – For properties with a private stormwater management facility.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Repetitive-Risk-Loss-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Repetitive Risk-Loss Disclosure Statement{' '}
          </span>
          – Refers to two or more claims of $1,000 or more by the National Flood
          Insurance Program within a 10-year period.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Virginia-Residential-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Residential Property Disclosure Statement and Acknowledgment{' '}
          </span>
          – Protects sellers from certain liabilities. Required for most
          residential sales unless exempt.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Virginia-Septic-System-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Septic System Disclosure{' '}
          </span>
          – Discloses to the buyer if the septic system is faulty and must be
          repaired after the sale.
        </li>
      </ol>
    </div>
  );
};

export default Virginia;
